document.addEventListener('variant:change', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  let previousVariant = event.detail.previousVariant; // Gives you access to the details of the previously selected variant
  let form = event.target; // The form that triggers the change
  const preorder = document.querySelector('.buy-buttons').dataset.preorder;
  if(preorder == 'preorder' && variant.available){
    document.querySelector('.buy-buttons button').innerText = 'PREORDER';
    console.log('is preorder');
  }

    if(preorder == 'Pre Order' && variant.available){
    document.querySelector('.buy-buttons button').innerText = 'Pre Order';
    console.log('is preorder');
  }

});